import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articles";

export default function HotTopics() {
  const { t } = useTranslation("home");
  const hotArticles = articles.slice(0, 4);

  return (
    <section className="bg-foreground-950 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end gap-3 mb-10">
          <span className="inline-block px-4 py-1 text-xs font-label text-background-50 border border-background-50/30 rounded-full whitespace-nowrap w-fit">
            {t("hotTopics.badge")}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-background-50 tracking-tight">
            {t("hotTopics.title")}
          </h2>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-thin">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex-shrink-0 w-[280px] md:w-[320px] group cursor-pointer"
            >
              <div className="bg-background-50 rounded-lg overflow-hidden transition-transform duration-300 group-hover:-translate-y-1">
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-1 text-xs font-label bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                      {article.categoryName}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-label font-medium text-foreground-900 text-sm leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.viewCount >= 10000
                        ? `${(article.viewCount / 10000).toFixed(1)}万`
                        : article.viewCount}
                    </span>
                    <span>{article.publishDate}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}